module.exports = __webpack_public_path__ + "img/image-01.6f0db68d.webp";